import React from "react";
import { PieChart } from "react-minimal-pie-chart";
import ATMSelectValue from "src/components/UI/atoms/formFields/ATMSelectValue/ATMSelectValue";
import { GoDotFill } from "react-icons/go";
import MOLAttendanceCalendar from "src/components/UI/molecules/MOLAttendanceCalendar/MOLAttendanceCalendar";

type Props = {
  studentAttendanceCount: any;
  startDate: any;
  setStartDate: any;
  studentAttendanceCalendar: any;
  batchOptions: any;
  setSelectBatch: any;
  selectBatch: any;
};

const StudentAttendanceListing = ({
  studentAttendanceCount,
  startDate,
  setStartDate,
  studentAttendanceCalendar,
  batchOptions,
  selectBatch,
  setSelectBatch,
}: Props) => {
  const chartAttendanceData = [
    {
      title: "Present",
      value: studentAttendanceCount?.totalPresent || 0,
      color: "#1b8040",
    },
    {
      title: "Absent",
      value: studentAttendanceCount?.totalAbsent || 0,
      color: "#b54747",
    },
    {
      title: "Holiday",
      value: studentAttendanceCount?.totalHoliday || 0,
      color: "#6B7280",
    },
  ];
  const chartPunchulityData = [
    {
      title: "OnTime",
      value: studentAttendanceCount?.totalOnTime || 0,
      color: "#6FA95B",
    },
    {
      title: "Late",
      value: studentAttendanceCount?.totalNotOnTime || 0,
      color: "#D97706",
    },
    {
      title: "Holiday",
      value: studentAttendanceCount?.totalNA || 0,
      color: "#6B7280",
    },
  ];
  return (
    <div>
      <div className="border border-slate-300 p-3 rounded-md flex justify-between">
        <div className="flex flex-col gap-2 border-r  pr-2">
          <div className="font-medium text-md ">Attendance</div>
          <div className="flex gap-4 items-center">
            <div className="w-[230px] m-0 p-0 h-[230px] ">
              <PieChart
                animate
                animationDuration={500}
                animationEasing="ease-out"
                center={[50, 50]}
                viewBoxSize={[90, 90]}
                data={chartAttendanceData}
                labelPosition={68}
                lengthAngle={360}
                lineWidth={50}
                paddingAngle={0}
                radius={30}
                startAngle={0}
                className=""
              />
            </div>
            <div className="flex flex-col gap">
              <span className="text-md font-medium">
                Total Days :{" "}
                {studentAttendanceCount?.totalPresent +
                  studentAttendanceCount?.totalAbsent +
                  studentAttendanceCount?.totalHoliday || 0}
              </span>
              <span className="text-md font-medium text-green-700">
                Present : {studentAttendanceCount?.totalPresent || 0}
              </span>
              <span className="text-md font-medium text-red-700">
                Absent : {studentAttendanceCount?.totalAbsent || 0}
              </span>
              <span className="text-md font-medium text-slate-500">
                Holiday : {studentAttendanceCount?.totalHoliday || 0}
              </span>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-2 border-r  pr-2">
          <div className="font-medium text-md">Punctuality</div>
          <div className="flex gap-4 items-center">
            <div className="w-[230px] m-0 p-0 h-[230px] ">
              <PieChart
                animate
                animationDuration={500}
                animationEasing="ease-out"
                center={[50, 50]}
                viewBoxSize={[90, 90]}
                data={chartPunchulityData}
                labelPosition={68}
                lengthAngle={360}
                lineWidth={50}
                paddingAngle={0}
                radius={30}
                startAngle={0}
                className=""
              />
            </div>
            <div className="flex flex-col gap">
              <span className="text-md font-medium">
                Total Days :{" "}
                {studentAttendanceCount?.totalOnTime +
                  studentAttendanceCount?.totalNotOnTime +
                  studentAttendanceCount?.totalNA || 0}
              </span>
              <span className="text-md font-medium text-lime-600">
                OnTime : {studentAttendanceCount?.totalOnTime || 0}
              </span>
              <span className="text-md font-medium text-amber-600	">
                Late : {studentAttendanceCount?.totalNotOnTime || 0}
              </span>
            </div>
          </div>
        </div>

        <div className="flex gap-5">
          <ATMSelectValue
            value={selectBatch}
            onChange={(value) => setSelectBatch(value)}
            options={batchOptions}
          />
        
        </div>
      </div>
      <div className="flex justify-between">
        <div className="shadow-lg w-[600px] mt-6">
          {studentAttendanceCalendar?.length ? (
            // <div className="grid grid-cols-7 gap-6 p-3 ">
            //   {studentAttendanceCalendar?.map((el: any, ind: any) => {
            //     return (
            //       <div
            //         className={`border rounded-full text-[14px]  px-[3px] py-[2px] cursor-pointer text-center ${
            //           el?.isPresent === "P"
            //             ? el?.cameOnTime === "NO"
            //               ? "bg-amber-600 text-white font-medium"
            //               : "bg-green-600 text-white font-medium"
            //             : el?.isPresent === "A"
            //             ? "bg-red-500 text-white font-medium"
            //             : el?.isPresent === "H"
            //             ? "bg-gray-500 text-white font-medium"
            //             : "bg-slate-100"
            //         }`}
            //       >
            //         {" "}
            //         {moment(el?.createdAt).format("DD")}
            //       </div>
            //     );
            //   })}
            // </div>
            <div>
              <MOLAttendanceCalendar data={studentAttendanceCalendar}/>
            </div>
          ) : (
            <div className="flex justify-center items-center h-[300px] text-red-600 font-medium">
              {" "}
              No Data Found
            </div>
          )}
        </div>
        <div className="mt-5">
          <div className="flex  items-center">
            <GoDotFill color="#D97706" size="2em" />{" "}
            <span className="text-sm font-medium">Present but late</span>
          </div>
          <div className="flex  items-center">
            <GoDotFill color="#16A34A" size="2em" />{" "}
            <span className="text-sm font-medium">Present On Time</span>
          </div>
          <div className="flex  items-center">
            <GoDotFill color="#EF4444" size="2em" />{" "}
            <span className="text-sm font-medium">Absent</span>
          </div>
          <div className="flex  items-center">
            <GoDotFill color="#6B7280" size="2em" />{" "}
            <span className="text-sm font-medium">Holiday</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentAttendanceListing;
